import * as React from 'react';
import * as styles from './closeIcon.css';

import { Close } from '../icons';

interface ICloseIconProps {
  onClick(): void;
}

export function CloseIcon({ onClick }: ICloseIconProps) {
  return (
    <div className={styles['close-icon']} onClick={onClick}>
      <Close />
    </div>
  );
}
